function parseJwt (token) {
  if(token === undefined || token.indexOf('.') === -1) {
    return false;
  }

  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

function init() {
  if (document.readyState === 'interactive') {
    initGaParameters();
  }
  else {
    document.addEventListener('DOMContentLoaded', initGaParameters.bind(this));
  }
}

function initGaParameters() {
  if (window.gaInitId && document.body.dataset.pageType === 'article') {
      setAllerGaArticleFields(window.gaInitId);
    }
    else if (document.body.dataset.pageType === 'front') {
      setAllerGaFrontPageFields();
    }

    window.infinityscroll.on('current-breakpoint-change', (breakpoint) => {
      if (document.body.dataset.pageType === 'article') {
        setAllerGaArticleFields(breakpoint.dataset.id, breakpoint.dataset.verticals)
      }
      if (document.body.dataset.pageType === 'front') {
        // Set scrollindex and other front page fields that migh change here when new front page breakpoint occurs
      }
    });
}

function setAllerGaFrontPageFields() {

  let aller_ga = window.aller_ga || {};
  aller_ga.verticals = [];
  let pageVerticals = aller_ga.pageVerticals;

  if (document.cookie !== undefined) {
    const getCookieValue = target => document.cookie.split('; ').find(row => row.startsWith(`${target}=`))?.split('=')[1];
    const getAbValue = () => parseInt(getCookieValue('ab-aller'),10) || 0;
    aller_ga.abGroup = `${getAbValue()}`;
  }

  let loggedInId = false;
  let loginToken = /login_token=(.*)/.exec(document.cookie.split('; ').find(row => row.startsWith('login_token='))) ?? false;
  if (loginToken) {
    const parsedLoginToken = parseJwt(loginToken[1]);
    loggedInId = parsedLoginToken?.data?.cc ?? false;
  }
  aller_ga.loggedInId = loggedInId;

  let googleOptimize = /GAX[0-9.]+([^.]+)\.[0-9]+\.([0-9]+)/.exec(document.cookie.split('; ').find(row => row.startsWith('_gaexp=')));
  if (googleOptimize && googleOptimize.length > 1 ) {
    aller_ga.googleOptimizeId = googleOptimize[1] + '|' + googleOptimize[2];
  }

  if (typeof pageVerticals === 'string') {

    let verticalArr = pageVerticals.split(',');

    if (Array.isArray(verticalArr) && verticalArr.length > 0) {

      const verticalPattern = /^[a-zåäöA-ZÅÄÖ_]+$/;
      pageVerticals = verticalArr.map( str => str.trim()).filter( str => str.match(verticalPattern));
      aller_ga.verticals = pageVerticals;
    }
  }
  window.aller_ga = aller_ga;
}

function setAllerGaArticleFields(articleId, verticals = false) {
  let gaArticleFields = document.getElementById(`gaArticleFields${articleId}`);
  let aller_ga = {};

  aller_ga.location = window.location.href;
  aller_ga.dimensionPageName = '1';
  aller_ga.dimensionPageValue = articleId;
  aller_ga.dimensionMobileWebsiteName = '2';
  aller_ga.dimensionMobileWebsiteValue = window.labDevice === 'desktop' ? 'No' : 'Yes';

  if (gaArticleFields.dataset?.commoncategories) {
    try {
      aller_ga.commonCategories = JSON.parse(gaArticleFields.dataset.commoncategories);
    } catch (e) {
      aller_ga.commonCategories = [''];
    }
  }
  if (verticals) {
    try {
      aller_ga.verticals = JSON.parse(verticals);
    } catch (e) {
      aller_ga.verticals = [];
    }
  }

  if (document.cookie !== undefined) {
    const getCookieValue = target => document.cookie.split('; ').find(row => row.startsWith(`${target}=`))?.split('=')[1];
    const getAbValue = () => parseInt(getCookieValue('ab-aller'),10) || 0;
    aller_ga.abGroup = `${getAbValue()}`;
  }

  let loggedInId = false;
  let loginToken = /login_token=(.*)/.exec(document.cookie.split('; ').find(row => row.startsWith('login_token='))) ?? false;
  if (loginToken) {
    const parsedLoginToken = parseJwt(loginToken[1]);
    loggedInId = parsedLoginToken?.data?.cc ?? false;
  }

  let googleOptimize = /GAX[0-9.]+([^.]+)\.[0-9]+\.([0-9]+)/.exec(document.cookie.split('; ').find(row => row.startsWith('_gaexp=')));
  if (googleOptimize && googleOptimize.length > 1 ) {
    aller_ga.googleOptimizeId = googleOptimize[1] + '|' + googleOptimize[2];
  }

  if (gaArticleFields) {
    let allerGaData = gaArticleFields.dataset;
    aller_ga.location = window.location.href;
    aller_ga.dimensionMobileWebsiteValue = window.labDevice === 'desktop' ? 'No' : 'Yes';
    aller_ga.seoTitle = allerGaData.seotitle;
    aller_ga.seoDescription = allerGaData.seodescription;
    aller_ga.plusLoggedIn = allerGaData.plusloggedin;
    aller_ga.allerPaywall = allerGaData.allerpaywall;
    aller_ga.loggedIn = allerGaData.loggedin;
    aller_ga.dimensionPageName = allerGaData.dimensionpagename;
    aller_ga.dimensionPageValue = allerGaData.dimensionpagevalue;
    aller_ga.dimensionMobileWebsiteName = allerGaData.dimensionmobilewebsitename;
    aller_ga.plusSubscriptionType = allerGaData.plussubscriptiontype;
    aller_ga.plusHasPlusAccess = allerGaData.plushasplusaccess;
    aller_ga.plusHasFreeMonth = allerGaData.plushasfreemonth;
    aller_ga.isPlusArticle = allerGaData.isplusarticle;
    aller_ga.collectOriginalUrl = allerGaData.collectoriginalurl;
    aller_ga.collectOriginalAuthor = allerGaData.collectoriginalauthor;
    aller_ga.collectOriginalTitle = allerGaData.collectoriginaltitle;
    aller_ga.collectOriginalFeaturedImage = allerGaData.collectoriginalfeaturedimage;
    aller_ga.collectOriginalDate = allerGaData.collectoriginaldate;
    aller_ga.id = articleId;
    aller_ga.postUniqueId = allerGaData.postuniqueid;
    aller_ga.postAuthor = allerGaData.postauthor;
    aller_ga.postTitle = allerGaData.posttitle;
    aller_ga.postDate = allerGaData.postdate;
    aller_ga.postModified = allerGaData.postmodified;
    aller_ga.seoKeywords = allerGaData.seokeywords;
    aller_ga.loggedInId = loggedInId;

    if (allerGaData.verticals) {
      try {
        aller_ga.verticals = JSON.parse(allerGaData.verticals);
      } catch (e) {
        aller_ga.verticals = [];
      }
    }

    if (allerGaData.isnativead === '1') {
      aller_ga.pageType = 'native';
      aller_ga.sponsorBrandName = allerGaData.sponsorbrandname;
      aller_ga.isAffiliate = '0';
      aller_ga.containAffiliate = '0';
    } else {
      aller_ga.pageType = 'article';
      aller_ga.isAffiliate = allerGaData.containaffiliate;
      aller_ga.containAffiliate = allerGaData.containaffiliate;
    }
  }

  window.aller_ga = aller_ga;
}

export default {
  init
};
